import { Component, OnInit, ChangeDetectionStrategy, AfterViewInit } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd';
import { _HttpClient } from '@delon/theme';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { URLS } from '../../../shared/constant/interface';
import { debounceTime } from 'rxjs/operators';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { Location } from '@angular/common';
import { DialogService } from 'icc-common-lib';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TikTokChannelEditComponent implements OnInit, AfterViewInit {
  static NAME = 'icc-msg-channel-edit';
  constructor(public http: _HttpClient, private fb: FormBuilder, private dialogService: DialogService,
    private location: Location,
    private activeRoute: ActivatedRoute) {
    this.activeRoute.params.subscribe((params: ParamMap) => {
      if(params['id']) {
        this.record.id = params['id'];
      }
    })
  }
  record: any = {};

  optionList: any[] = [];
  provider = null;
  isEdit = false;
  form: FormGroup = this.fb.group({
    id: new FormControl(null),
    providerId: new FormControl(null, [Validators.required]),
    name: new FormControl(null, [Validators.maxLength(50), Validators.required]),
    identity: new FormControl(null, [Validators.maxLength(20), Validators.required, Validators.pattern('^[a-zA-Z][a-zA-Z0-9_-]*$')]),
    msgType: new FormControl(null),
    appKey: new FormControl(null, [Validators.required, Validators.maxLength(50)]),
    appSecret: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
    openId: new FormControl(null, [Validators.maxLength(100), Validators.required]),
    // speed: new FormControl(null, [Validators.required, Validators.pattern('^[0-9]*$'), Validators.max(600)]),
    hidControl: new FormControl(null, [Validators.required]),
    hidNameControl: new FormControl(null, [Validators.required]),
    state: new FormControl(null), // 通道状态
    channelNum: new FormControl(null, [Validators.required]), // 用户昵称
  });
  checkDisable = false;
  subject = '抖音渠道';
  isSubmit = false;
  nameHid = true;
  identityHid = true;
  ngOnInit(): void {
    const urlSel = URLS.searchChannelProvider.url;
    this.form.get('state').setValue(1);
    if (this.record.id > 0) {
      const str = sessionStorage.getItem(`tiktok_${this.record.id}`);
      if(str) {
        const json = JSON.parse(str);
        this.record = {...this.record, ...json};
      }
      this.http.post(urlSel, 7).subscribe(res => {
        this.optionList = res.data;
        this.isEdit = true;
        this.form.get('id').setValue(this.record.id);
        this.form.get('identity').setValue(this.record.identity);
        this.checkDisable = true;
        this.form.get('providerId').setValue(this.record.providerId);
        this.form.get('msgType').setValue(this.record.msgType);
        this.form.get('name').setValue(this.record.name);
        this.form.get('appKey').setValue(this.record.appKey);
        this.form.get('appSecret').setValue(this.record.appSecret);
        this.form.get('state').setValue(+this.record.state);
        this.form.get('openId').setValue(this.record.openId);
        this.form.get('channelNum').setValue(this.record.channelNum);
      });
    } else {
      // this.http.get(url)
      this.http.post(urlSel, 7).subscribe(res => {
        this.optionList = res.data;
        this.form.get('providerId').setValue(this.optionList[0].id);
      });
    }
    this.form.get('hidControl').setValue(1);
    this.form.get('hidNameControl').setValue(1);
  }
  ngAfterViewInit() {
    if(this.record.id) {
      sessionStorage.removeItem(`tiktok_${this.record.id}`);
    }
  }
  save(value: any) {
    let url = URLS.addTiktokManagement.url;
    if (this.record.id > 0) {
      url = URLS.editTiktokManagement.url;
    }
    this.isSubmit = true;
    this.http.post(url, value).subscribe(res => {
      if (res.status === 0) {
        if (this.record.id > 0) {
          this.dialogService.notification.success(this.subject, '编辑成功');
        } else {
          this.dialogService.notification.success(this.subject, '新增成功');
        }
        // this.modal.close(true);
        this.close();
      } else {
        this.isSubmit = false;
        if (this.record.id > 0) {
          this.dialogService.notification.error(this.subject, '编辑失败' + res.errorMsg);
        } else {
          this.dialogService.notification.error(this.subject, '新增失败:' + res.errorMsg);
        }
      }
    });
  }

  close() {
    // this.modal.destroy();
    this.location.back();
  }
  ngNameChange() {
    // 防抖时间，单位毫秒
    debounceTime(1000);
    this.record.id = this.form.get('id').value;
    this.record.name = this.form.get('name').value;
    this.http.post(URLS.checkChannelName.url, this.record).subscribe(res => {
      if (res.status === -1) {
        this.nameHid = false;
        this.form.get('hidNameControl').setValue(null);
      } else {
        this.nameHid = true;
        this.form.get('hidNameControl').setValue(1);
      }
    });
  }
  ngIdentityChange() {
    // 防抖时间，单位毫秒
    this.record.id = this.form.get('id').value;
    this.record.identity = this.form.get('identity').value;
    this.http.post(URLS.checkChannelIdentity.url, this.record).subscribe(res => {
      if (res.status === -1) {
        this.identityHid = false;
        this.form.get('hidControl').setValue(null);
      } else {
        this.identityHid = true;
        this.form.get('hidControl').setValue(1);
      }
    });
  }
}
